import { useState } from "react";
import { useAccountRegister } from "@made-people/grease-account";
import { useTranslate } from "@made-people/grease-translations";

type FieldErrors = {
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  general?: string;
};

export const useRegisterForm = ({ onSuccess }: { onSuccess: () => void }) => {
  const translate = useTranslate();
  const { execute, loadingState } = useAccountRegister();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState<FieldErrors>({});

  const handleSubmit = async () => {
    if (loadingState === "loading") return;
    setErrors({});
    const result = await execute({
      email,
      password,
      firstName,
      lastName,
    });
    if (result.success) {
      onSuccess();
    } else if (result.error === "Account_InvalidEmail") {
      setErrors({ email: translate("Account_InvalidEmail_Helper_Text") });
    } else if (result.error === "Account_PasswordNotSecure") {
      setErrors({
        password: translate("Account_PasswordNotSecure_Helper_Text"),
      });
    } else if (result.error === "Account_EmailAlreadyExists") {
      setErrors({
        email: translate("Account_EmailAlreadyExists_Helper_Text"),
      });
    } else if (result.error === "Account_MissingFields") {
      setErrors({ general: translate(result.error) });
    } else {
      setErrors({ general: translate(result.error) });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const clearFieldError = (field: keyof FieldErrors) => {
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: undefined,
      }));
    }
  };

  return {
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    password,
    setPassword,
    errors,
    handleSubmit,
    handleKeyDown,
    clearFieldError,
    loadingState,
  };
};
